export default {
  title: 'Dettagli di spedizione',
  buttons: {
    save: 'Salva',
  },
};
